import React from 'react';
import { Image } from '../../../../wag-react/next-components/image';
import { WalkerOfferedServicesResponse } from '../../../../types/api';
import { capitalizeFirstLetter } from '../../../OvernightServicePreferencesContainer/helpers';
import { formatPrice } from './helpers/formatPrice';
import { serviceAssetMap } from './assets';
import { ServiceList } from './ServiceList';
import { Box } from '../../../../wag-react/next-components/box';
import { Typography } from '../../../../wag-react/components/Typography';
type Props = {
  rates: Array<{
    serviceName: WalkerOfferedServicesResponse['items'][number]['serviceCategory'];
    minPrice: number;
  }>;
  showIcon?: boolean;
};
export const WalkerServicesRates = ({
  rates,
  showIcon = true
}: Props) => <Box data-sentry-element="Box" data-sentry-component="WalkerServicesRates" data-sentry-source-file="WalkerServicesRates.tsx">
    <Typography variant="h4" color="#272727" m="0" mb="14px" fontFamily="muliBold" fontSize={['16px', '18px']} data-sentry-element="Typography" data-sentry-source-file="WalkerServicesRates.tsx">
      Starting Rates
    </Typography>

    <ServiceList data-sentry-element="ServiceList" data-sentry-source-file="WalkerServicesRates.tsx">
      {rates.map(rate => <Box key={rate.serviceName} px="14px" py="4px" display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" alignItems="center">
            {showIcon && <Box display="flex" alignItems="center" justifyContent="center" width="24px" height="24px" mr="6px">
                <Image src={serviceAssetMap[rate.serviceName.replace('-', '_')]?.icon} width={rate.serviceName === 'walk' ? '13px' : '24px'} height={rate.serviceName === 'walk' ? '21px' : '24px'} alt={rate.serviceName} mr={2} />
              </Box>}

            <Typography variant="body1" fontFamily="muliBold" fontSize="14px" color="#272727">
              {capitalizeFirstLetter(rate.serviceName)}
            </Typography>
          </Box>

          <Box display="flex" alignItems="center">
            <Typography variant="body1" fontSize="14px" fontFamily="muliBold" color="#272727">
              {formatPrice(rate.minPrice)}
            </Typography>

            {(rate.serviceName === 'boarding' || rate.serviceName === 'sitting') && <Typography variant="legal" fontSize="12px" fontFamily="muliSemiBold" color="#818181" ml={1}>
                per night
              </Typography>}
          </Box>
        </Box>)}
    </ServiceList>
  </Box>;